import React from 'react'
import Header from '../components/Header'
import GameMaps from '../components/GameMaps'

function MapsPage() {
    return (
        <>
            <Header />
            <GameMaps />
        </>
    )
}

export default MapsPage